<template lang="pug">
.reject-sub-final-scope-dialog
  el-dialog(
    :visible="visible"
    @close="$emit('cancel')"
    :title="showSubtitle ? $t('提示') : $t('请填写拒绝理由')"
    :close-on-click-modal="false"
    center
  )
    .divider(v-if="showSubtitle")
      span {{ $t('以下推荐供应商未分配Sub SOW, 请添加备注') }}:

    el-table(
      :data="rejectedVendors"
    )
      el-table-column(
        :label="$t('供应商')"
        align="center"
        show-tooltip-when-overflow
      )
        template(slot-scope="scope")
          span {{ scope.row.vendor_name_ch + '/' + scope.row.vendor_name }}
      el-table-column(
        :label="$t('推荐方')"
        align="center"
      )
        template(slot-scope="scope")
          span {{ $t(scope.row.recommend_resource) }}
      el-table-column(
        :label="$t('拒绝理由')"
        align="center"
        :class="'refuse_reason_input'"
        :placeholder="$t('拒绝原因不超过100字')"
      )
        template(slot-scope="scope")
          el-form(
            :model="scope.row"
            :rules="rules"
            :ref="'form' + scope.row.vendor_id"
          )
            el-form-item(
              prop="refuse_reason"
            )
              el-input(
                v-model="scope.row.refuse_reason"
              )
    footer-button(
        style="margin-top: 30px"
        @confirm="onConfirm"
        @cancel="$emit('cancel')"
      )
</template>

<script>
import FooterButton from '@/components/FooterButton'

export default {
  components: {
    FooterButton
  },
  props: {
    rejectedVendors: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      default () {
        return false
      }
    },
    showSubtitle: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    const validateMineParamsValueInput = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('请填写拒绝原因')))
      } if (value.length > 100) {
        return callback(new Error(this.$t('拒绝原因不超过100字')))
      } else {
        callback()
      }
    }
    return {
      intro: '',
      rules: {
        refuse_reason: [
          { validator: validateMineParamsValueInput, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async onConfirm () {
      Promise.all(this.rejectedVendors.map(i => {
        return this.$refs['form' + i.vendor_id].validate()
      }))
        .then(() => {
          this.$emit('confirm')
        })
    }
  }
}
</script>

<style lang="stylus">
.reject-sub-final-scope-dialog
  .el-dialog
    width 620px
  .el-dialog__header
    text-align left
  .el-dialog__body
    text-align center
    padding-bottom 40px
  .divider
    display flex
    margin-bottom 30px
    hr
      width calc((100% - 380px)/2)
      border-bottom none
  .el-table__row
    td
      &:nth-child(3)
        .cell
          margin-top 13px
    .el-form.el-form-item
      margin-bottom 13px
</style>
